import React, { Component } from 'react';
import _ from 'lodash';
import { Grid } from 'react-bootstrap';

import Header from '../../components/Common/Header/Header';
import Dashboard from '../../container/Recruiter/Dashboard/Dashboard';
import PoolImport from '../../container/Recruiter/PoolImport/PoolImport';
import PoolViewAll from '../../container/Recruiter/PoolViewAll/PoolViewAll';
import PoolAddCandidates from '../../container/Recruiter/PoolAddCandidates/PoolAddCandidates';
import RecruiterJobReport from '../../container/Recruiter/RecruiterJobReport/RecruiterJobReport';
import PoolRecruiter from '../../container/Recruiter/PoolRecruiter/PoolRecruiter';
import ProfileEdit from '../../container/Recruiter/ProfileEdit/ProfileEdit';
import Footer from '../../components/Recruiter/Footer/Footer';
import RecruiterAllReports from '../../container/Recruiter/RecruiterAllReports/RecruiterAllReports';
import InterviewSchedulerLayout from './InterviewSchedulerLayout';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import RecruiterInterviewContainer from '../../container/Recruiter/RecruiterInterviewDetails/RecruiterInterviewContainer/RecruiterInterviewContainer';
import RecruiterInterviewView from '../../container/Recruiter/RecruiterInterviewDetails/InterviewViewRecruiter/InterviewViewRecruiter';

/**
* @desc Layout for recruiter
* @version 
* @author Lakshmikanth 
*/
class RecruiterLayout extends Component {

  render() {
    return (
      <div className="root recruiter">
        <div className="app-container recruiter">
          <Header />
          <div className="app-body">
            <Grid>
              <PropsRoute exact path="/recruiter/dashboard" component={Dashboard} />
              <PropsRoute exact path="/recruiter/pool-import" component={PoolImport} />
              <PropsRoute exact path="/recruiter/pool-import/:jobId" component={PoolImport} />
              <PropsRoute exact path="/recruiter/pool-import/candidate/:activeCandidateId/:jobId" component={ProfileEdit} />
              <PropsRoute exact path="/recruiter/pool-view-all" component={PoolViewAll} />
              <PropsRoute exact path="/recruiter/pool/:id" component={PoolRecruiter} />
              <PropsRoute exact path="/recruiter/pool-add-candidates/:id" component={PoolAddCandidates} />
              <PropsRoute exact path="/recruiter/pool/list/:id" component={RecruiterJobReport} />
              <PropsRoute exact path="/recruiter/recruiter-all-reports" component={RecruiterAllReports} />
              <PropsRoute exact path="/recruiter/interview-scheduler" component={InterviewSchedulerLayout} /> 
              <PropsRoute exact path="/recruiter/interview" component={RecruiterInterviewContainer} /> 
              <PropsRoute exact path="/recruiter/interview-view" component={RecruiterInterviewView} /> 

            </Grid>
          </div>
          <div className="simpleLayoutFooter">
            <Footer/>
          </div>
        </div>
      </div>
    );
  }
}
/**
* @desc merging props
* @param component ,rest
* @return component,finalprops
*/
const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}
/**
* @desc adding props to router
* @param component ,rest
* @return merged props,component
*/
const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }} />
  );
}

export default RecruiterLayout;



// WEBPACK FOOTER //
// ./src/hoc/layout/RecruiterLayout.js